import React, { useEffect, useRef } from 'react';
import { Image, ScrollView, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import styles from './reading-listening.style';
import { Title } from '../..//title/title.component';
import { useColors } from '../../../hooks/lesson-player.context';
import { useActivityContext } from '../../../hooks/use-activity.context';
import { useScroll } from '../../../hooks/use-scroll';
import trueBeginnerStr from '../../../utils/true-beginner-str';
import { AudioPlayerWithProvider } from '../../audio-player/audio-player-with-provider';
import { CollapsableText } from '../../collapsable-text/collapsable-text';
import { ContinueButton } from '../../continue-button/continue-button';
import { Instruction } from '../../instruction/instruction.component';
import { ThemedView } from '../../themed-view';
export function ReadingListening() {
  const scrollRef = useRef<ScrollView>(null);
  const { scrollToTop } = useScroll(scrollRef);
  const colors = useColors();

  const {
    currentIndex,
    currentActivity: activity,
    isCurrentActivityComplete: isComplete,
    completeCurrentActivity: completeActivity,
    goNext,
  } = useActivityContext();

  useEffect(() => {
    scrollToTop();
  }, [currentIndex, scrollToTop]);

  return (
    <>
      <ScrollView ref={scrollRef} style={styles.section}>
        <SafeAreaView edges={['bottom']} style={styles.container}>
          <Instruction
            text={trueBeginnerStr(
              activity,
              'instructions',
              activity.trueBeginner
            )}
          />
          {!!activity?.imagen && (
            <Image style={styles.image} source={{ uri: activity?.imagen }} />
          )}
          <ThemedView style={[styles.view]}>
            <Title style={[styles.title]}>{activity?.title}</Title>
            <AudioPlayerWithProvider
              barContainerColor={colors.primaryOpacity}
              inactiveColor={colors.onPrimary}
              activeColor={colors.onPrimary}
              onReproduce={completeActivity}
              url={activity?.audio}
            />
          </ThemedView>
          {!!activity?.audio && (
            <View style={styles.floatView}>
              <CollapsableText
                isMarkdown
                isHtml
                translationText={activity?.transcriptionTranslation}
                text={activity?.transcription}
              />
            </View>
          )}
        </SafeAreaView>
      </ScrollView>
      {isComplete && <ContinueButton onPress={goNext} />}
    </>
  );
}
